export const productInfoAdapter = (data, quotation) => {
	// Crear un mapa de recetas por id para búsqueda rápida
	const recipeMap = (quotation?.recipe || []).reduce((acc, recipe) => {
		acc[recipe.id] = recipe;
		return acc;
	}, {});
	
	// Crear mapas de productos de cotización por code_internal
	const allMagistralProducts = [
		...(quotation?.magistral_products || []),
		...(quotation?.magistral_products_prepare || [])
	];
	
	const magistralProductMap = allMagistralProducts.reduce((acc, qProduct) => {
		if (qProduct.code_internal) {
			acc[qProduct.code_internal] = qProduct;
		}
		return acc;
	}, {});
	
	// Crear mapa de productos comerciales por code_internal
	const commercialProductMap = (quotation?.commercial_products || []).reduce((acc, cProduct) => {
		if (cProduct.code_internal) {
			acc[cProduct.code_internal] = cProduct;
		}
		return acc;
	}, {});


	const products = data?.map((product,index) => {
		const disscount = Number(product?.discount?.value) / 100
		const priceUnitWIthoutDiscount =  Number(product?.total) / (Number(product?.quantity) * (1 - disscount));
		const disscountComercialProduct = ((Number(product?.unit_price) - (Number(product?.total) / Number(product?.quantity))) / Number(product?.unit_price)) * 100;
		const finalPriceUnit = Number(product?.total) / Number(product?.quantity);
		
		// Buscar el producto en la cotización: primero comerciales, luego magistrales
		const quotationProduct = commercialProductMap[product?.code_internal] || magistralProductMap[product?.code_internal];
		// Obtener el recipe_id del producto de cotización
		const recipeId = quotationProduct?.recipe_id;
		// Obtener el patient de la receta correspondiente
		const associatedRecipe = recipeMap[recipeId];
		const patient = associatedRecipe?.patient || null;

	console.log("product", product);
		console.log("priceunitewithoutdiscount", priceUnitWIthoutDiscount);
		return {
			key: product.id_pharol,
			name: product.name,
			quantity: product.quantity,
			unit_price: product?.quotation_price ? product?.quotation_price?.base_unit_price : product.unit_price,
			total: product.total,
			recipe: product.recipe || associatedRecipe?.url,
			code_internal: product.code_internal,
			final_price_unit: finalPriceUnit,
			id_pharol: product.id_pharol,
			laboratory: product.laboratory,
			bioequivalent: product.bioequivalent,
			promotions: product.promotions,
			image: product.original_image,
			category: product.category,
			prescryption_type: product.prescryption_type,
			discount: product?.quotation_price ? product?.quotation_price?.discount_value : disscountComercialProduct,
			stock: product.stock,
			total_product: product.valid_data_payment.total,
			observation_reject_recipe: product?.observation_reject_recipe,
			validation_product: product?.validation_product,
			slug: product?.slug,
			reverse: product?.reverse,
			reverse_quantity: product?.reverse_quantity,
			reverse_total: product?.reverse_total,
			reverse_unit_price: product?.reverse_unit_price,
			indication: product?.indication,
			patient: patient
		};
	});
	return products;
};
